import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'faire_direct-sign_up_landing_page-view';
/**
 * faire-direct-sign-up&#x2F;landing-page&#x2F;view
 */
export function trackFaireDirectSignUpLandingPageView(brandSubdomain) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { brandSubdomain },
    });
}
